import type { ReactElement } from "react";
import { Skeleton, SkeletonStatus } from "@/components/atoms";
import "./TableSkeleton.scss";

export interface TableSkeletonProps {
  columnCount: number;
  rowCount?: number;
  hasActions?: boolean;
  actionCount?: number;
}

/** Loading placeholder matching Table layout for CMS list views. */
export function TableSkeleton({
  columnCount,
  rowCount = 5,
  hasActions = true,
  actionCount = 2,
}: TableSkeletonProps): ReactElement {
  return (
    <SkeletonStatus label="Cargando tabla..." className="table-skeleton">
      <div className="table__wrapper">
        <table className="table-skeleton__table">
          <thead className="table-skeleton__head">
            <tr>
              {Array.from({ length: columnCount }).map((_, index) => (
                <th
                  key={`table-skeleton-head-${index}`}
                  className="table-skeleton__cell"
                  aria-hidden="true"
                >
                  <Skeleton variant="text" width="70%" height={16} className="table-skeleton__cell--head" />
                </th>
              ))}
              {hasActions ? (
                <th
                  className="table-skeleton__cell table-skeleton__cell--actions"
                  aria-hidden="true"
                >
                  <Skeleton className="table-skeleton__cell--head" variant="text" width={64} height={16} />
                </th>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rowCount }).map((_, rowIndex) => (
              <tr
                key={`table-skeleton-row-${rowIndex}`}
                className="table-skeleton__row"
                aria-hidden="true"
              >
                {Array.from({ length: columnCount }).map((__, cellIndex) => (
                  <td
                    key={`table-skeleton-cell-${rowIndex}-${cellIndex}`}
                    className="table-skeleton__cell table-skeleton__cell--content"
                  >
                    <Skeleton
                      variant="text"
                      width={cellIndex === 0 ? "85%" : "60%"}
                      height={16}
                    />
                  </td>
                ))}
                {hasActions ? (
                  <td className="table-skeleton__cell table-skeleton__cell--actions">
                    <div className="table-skeleton__actions">
                      {Array.from({ length: actionCount }).map((_, actionIndex) => (
                        <Skeleton
                          key={`table-skeleton-action-${rowIndex}-${actionIndex}`}
                          width={20}
                          height={20}
                          borderRadius="sm"
                        />
                      ))}
                    </div>
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SkeletonStatus>
  );
}
